export default "__VITE_ASSET__BW_d4rye__"